import { BrowserModule } from "@angular/platform-browser";
import { NgModule } from "@angular/core";

import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { MaterialModule } from "./material.module";
import { HomeModule } from "./home/home.module";
import { LoginComponent } from "./login/login.component";
import { ForgotPasswordComponent } from "./forgot-password/forgot-password.component";
import { ResetPasswordComponent } from "./reset-password/reset-password.component";
import { PageNotFoundComponent } from "./page-not-found/page-not-found.component";
import { CoreModule } from "./core/core.module";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withInterceptorsFromDi,
} from "@angular/common/http";
import { AuthInterceptor } from "./http.interceptor";
import { SharedModule } from "./shared/shared.module";
import { HeaderComponent } from "./header/header.component";
import { TranslateModule } from "@ngx-translate/core";
import { LoaderInterceptorService } from "./loader-interceptor.service";
import { LoaderComponent } from "./loader/loader.component";
import player from "lottie-web";
import { CustomMatPaginatorIntl } from "./custom-mat-paginator-int";
import { DashboardModule } from "./dashboard/dashboard.module";
import { MatPaginatorIntl } from "@angular/material/paginator";
import { LottieComponent, provideLottieOptions } from "ngx-lottie";

export function playerFactory() {
  return player;
}

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    HeaderComponent,
    ForgotPasswordComponent,
    ResetPasswordComponent,
    PageNotFoundComponent,
    LoaderComponent,
  ],
  bootstrap: [AppComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    MaterialModule,
    FormsModule,
    ReactiveFormsModule,
    HomeModule,
    DashboardModule,
    TranslateModule.forRoot(),
    CoreModule,
    SharedModule,
    BrowserAnimationsModule,
    LottieComponent,
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: LoaderInterceptorService,
      multi: true,
    },
    {
      provide: MatPaginatorIntl,
      useClass: CustomMatPaginatorIntl,
    },
    provideHttpClient(withInterceptorsFromDi()),
    provideLottieOptions({ player: playerFactory }),
  ],
})
export class AppModule {}
